<template lang="pug">
.switch__container
  input.switch.switch--shadow(ref='switchButton', :id='switchId', :value='switchValue', type='checkbox')
  label(:for='switchId', :id='switchId', @click='changeSwitchValue')
</template>

<script>

export default  {
	props: {
    switchValue: Boolean,
    switchId: Number
  },
  mounted() {
    this.$refs.switchButton.checked = this.switchValue;
  },
	methods: {
		changeSwitchValue() {
			this.$emit('switchValueChanged', this.switchValue);
		}
	}
}
</script>

<style scoped lang="scss">
.switch {
  position: absolute;
  margin-left: -9999px;
  visibility: hidden;
  display: none;
}

.switch + label {
  display: block;
  position: relative;
  cursor: pointer;
  outline: none;
  user-select: none;
}

.switch--shadow:checked + label {
  padding: 1px;
  width: 20px;
  height: 10px;
  background-color: #8ce196;
  border-radius: 6px;
  transition: all 0.4s;
}

.switch--shadow + label {
  padding: 1px;
  width: 20px;
  height: 10px;
  background-color: #dddddd;
  border-radius: 6px;
  transition: all 0.4s;
}

.switch--shadow + label:before,
.switch--shadow + label:after {
  display: block;
  position: absolute;
  top: 1px;
  left: 1px;
  bottom: 1px;
  content: '';
}

.switch--shadow + label:after {
  width: 10px;
  background-color: #fff;
  border-radius: 100%;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  transition: all 0.4s;
}

.switch--shadow:checked + label:before {
  background-color: #dddddd;
}

.switch--shadow:checked + label:after {
  transform: translateX(10px);
}
</style>
